import React from "react";
import StoreAction from "../constants/store-action";
import { PaymentType } from "@wayke-se/ecom";
import UserEvent from "../constants/user-event";
import { formatPrice, formatPercentage } from "../utils/helpers";
import { addSizeQuery } from "../utils/image";
import { getPaymentMethodTitle } from "../utils/payment";
const getUserEventFromPaymentType = (type) => {
    switch (type) {
        case PaymentType.Cash:
            return UserEvent.PAYMENT_TYPE_CASH_CHOSEN;
        case PaymentType.Lease:
            return UserEvent.PAYMENT_TYPE_LEASING_CHOSEN;
        case PaymentType.Loan:
            return null;
    }
};
const createLoanExplanation = (loanDetails) => {
    const formattedInterest = formatPercentage(loanDetails.getInterests().interest);
    const formattedLoanAmount = formatPrice(loanDetails.getCreditAmount());
    const duration = loanDetails.getDurationSpec().current;
    const loanExplanation = `* Beräknat på ${formattedLoanAmount} kr, ${duration} mån, ${formattedInterest}%.`;
    return loanExplanation;
};
export default (props) => {
    const handlePaymentMethodClick = () => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "payment",
            name: "externalId",
            value: props.paymentOption.externalId,
        }, () => {
            const financialProductCode = props.paymentOption.type === PaymentType.Loan
                ? props.paymentOption.loanDetails.getFinancialProductCode()
                : "";
            props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
                type: "payment",
                name: "financialProductCode",
                value: financialProductCode,
            }, () => {
                props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
                    type: "payment",
                    name: "paymentType",
                    value: props.paymentOption.type,
                }, () => {
                    const userEvent = getUserEventFromPaymentType(props.paymentOption.type);
                    const hasUserEvent = userEvent !== null;
                    if (hasUserEvent) {
                        props.onIncompleteUserEvent(userEvent);
                    }
                    props.onProceedToNextStep();
                });
            });
        });
    };
    const title = getPaymentMethodTitle(props.paymentOption.type);
    const scaledImage = addSizeQuery(props.paymentOption.logo, 100, 60);
    const isLoan = props.paymentOption.type === PaymentType.Loan;
    let formattedPrice = null;
    let loanExplanation = null;
    if (isLoan) {
        const loanDetails = props.paymentOption.loanDetails;
        formattedPrice = formatPrice(loanDetails.getCosts().monthlyCost);
        loanExplanation = createLoanExplanation(loanDetails);
    }
    else {
        formattedPrice = formatPrice(props.paymentOption.price);
    }
    return (React.createElement("li", { className: "option-list-item" },
        React.createElement("button", { className: "option-list-action", onClick: handlePaymentMethodClick },
            React.createElement("div", { "data-ecom-columnrow": "" },
                React.createElement("div", { className: "column" },
                    React.createElement("div", { className: "option-list-action-title" },
                        title,
                        React.createElement("i", { className: "icon-arrow-right m-l-half" })),
                    React.createElement("div", { className: "option-list-action-subtitle" }, props.paymentOption.name),
                    React.createElement("div", { className: "option-list-action-meta" },
                        formattedPrice,
                        " ",
                        props.paymentOption.unit,
                        " "),
                    !!loanExplanation && (React.createElement("div", { className: "option-list-action-meta" },
                        React.createElement("span", { className: "text-dark-lighten" }, loanExplanation)))),
                props.paymentOption.logo && (React.createElement("div", { className: "column minimal" },
                    React.createElement("img", { src: scaledImage, alt: "logotype", className: "l-block", style: { maxWidth: "100px", maxHeight: "60px" } })))))));
};
